import React from "react";
import { Button, Badge } from "@mui/material";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

const FiltersButton = ({ onClick, filtersCount }) => {
    const { getFontSize, getContainerHeight } = useResponsiveStyles();
    return (
        <Badge
            badgeContent={filtersCount}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            sx={{
                "& .MuiBadge-badge": {
                    ...getFontSize("body1"),
                    backgroundColor: "#ED1C24",
                    color: "white",
                    fontWeight: 700,
                },
            }}
        >
            <Button
                variant="outlined"
                onClick={onClick}
                sx={{
                    ...styles.filterButton,
                    ...getContainerHeight("filter-height"),
                }}
            >
                <div className="text-gray-600">
                    <img
                        src="/icons/tune.svg"
                        alt="Filters"
                        className="w-4 h-4 mr-2"
                    />
                </div>
                <span
                    style={{
                        ...getFontSize("body1"),
                        color: "#767676",
                        textTransform: "capitalize",
                        letterSpacing: 0.4,
                    }}
                >
                    Filters
                </span>
            </Button>
        </Badge>
    );
};

const styles = {
    filterButton: {
        borderWidth: "0.5px",
        borderColor: "#767676",
        display: "flex",
        alignItems: "center",
    },
};

export default FiltersButton;
